import { useLocation } from "react-router";
import { usePageTitle } from "@/hooks";

/**
 * AutoPageTitle component that automatically sets page titles based on routes
 * This provides fallback titles for pages that don't explicitly set them
 */
export const AutoPageTitle = (): null => {
  const location = useLocation();

  // Only auto-set title if we're not on auth pages
  const shouldAutoSetTitle = !location.pathname.includes("/auth/");

  // Use the hook but don't pass a specific page name - let it auto-detect
  usePageTitle(null, shouldAutoSetTitle);

  return null; // This component doesn't render anything
};
